export default "__VITE_ASSET__C_fXRX$t__"